import { useContext } from 'react'
import { ShoppingCartContext, ShoppingCartContextType } from '../context/ShoppingCartContext'

export const useShoppingCart = (): ShoppingCartContextType => {
  const context = useContext(ShoppingCartContext)

  if (!context) {
    throw new Error('useShoppingCart debe usarse dentro de ShoppingCartProvider')
  }

  return context
}
